import { FormControl, FormHelperText, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import React from 'react';

interface SelectDropdownProps {
  label?: string;
  value?: string;
  children?: JSX.Element[];
  onChange?: (e: SelectChangeEvent) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  defaultValue?: string;
  className?: string;
  growOnMobile?: boolean;
  minWidth?: boolean;
  placeholder?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export default function CustomSelectDropdown({
  label,
  onChange,
  value,
  children,
  className,
  disabled,
  fullWidth,
  error,
  helperText,
  defaultValue,
  growOnMobile,
  minWidth,
  placeholder,
  onClick
}: SelectDropdownProps) {
  return (
    <div className={`${growOnMobile ? 'w-full ' + (minWidth ? 'sm:w-[200px] ' : '') : ''}-mb-0.5`} onClick={onClick}>
      <FormControl fullWidth={fullWidth ?? growOnMobile} error={error} className={className}>
        {label && <InputLabel variant={'filled'}>{label}</InputLabel>}
        <Select
          label={label}
          variant={label ? 'filled' : 'outlined'}
          value={value}
          disabled={disabled}
          onChange={(e) => {
            onChange?.(e);
          }}
          defaultValue={defaultValue}
          displayEmpty
        >
          {placeholder && (
            <MenuItem value={''} className={'opacity-50 '} disabled>
              <span className={'opacity-50'}>{placeholder}</span>{' '}
              {/* Add a negative margin on the right to prevent width from changing between placeholder/value */}
            </MenuItem>
          )}
          {children}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
}
